import MediaUploadBase from 'admin/editor/components/media_upload_base';
import ImagesLoaded from 'imagesloaded';

export default class MediaUploadElement extends MediaUploadBase {
  shouldShowButton() {
    return $('input[name="page_type"]').val() !== 'user';
  }

  addCustomListeners() {
    var that = this;
    // $('.replace-build-image').fileupload({
    //   dataType: 'html',
    //   progressInterval: 20,
    //   bitrateInterval: 100,
    //   dropZone: null,
    //   add: function(e, data) {
    //     var url, asset, $container
    //     $container = that.parentContainer(this);
    //     asset = parseInt($container.find('img').attr('class'), 10);
    //     url = that.baseUrl() + asset + '/replace?update_type=image';
    //     that.activeElementID = $container.attr('id');
    //     $container.replaceWith(that.build_image_placeholder());

    //     data.url = url;

    //     data.submit();
    //   },
    //   done: function (e, data) {
    //     $('.bar').css("width", 0);
    //     $('.progress').addClass('fade');

    //     var $image = $(data.result);
    //     ImagesLoaded($image, function(){
    //       $image.attr('id', that.activeElementID)
    //       $('.build-image-placeholder:first').replaceWith($image);

    //       that.learnEditor.save_page("Before Replace Image Element");
    //     }.bind(that));
    //   }
    // });
  }
}
